import React from 'react';

export interface GlassBadgeProps {
  variant?: 'success' | 'warning' | 'danger' | 'info' | 'default';
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md';
}

export const GlassBadge: React.FC<GlassBadgeProps> = ({
  variant = 'default',
  children,
  className = '',
  size = 'md',
}) => {
  const getVariantStyles = (): React.CSSProperties => {
    const baseStyles: React.CSSProperties = {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: size === 'sm' ? '2px 8px' : '4px 12px',
      fontSize: size === 'sm' ? 'var(--text-xs)' : 'var(--text-sm)',
      fontWeight: 'var(--font-medium)',
      borderRadius: 'var(--radius-full)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      border: '1px solid',
      whiteSpace: 'nowrap',
    };

    switch (variant) {
      case 'success':
        return {
          ...baseStyles,
          background: 'rgba(54, 211, 153, 0.15)',
          color: 'var(--success)',
          borderColor: 'rgba(54, 211, 153, 0.25)',
        };
      case 'warning':
        return {
          ...baseStyles,
          background: 'rgba(245, 200, 76, 0.15)',
          color: 'var(--warning)',
          borderColor: 'rgba(245, 200, 76, 0.25)',
        };
      case 'danger':
        return {
          ...baseStyles,
          background: 'rgba(248, 113, 113, 0.15)',
          color: 'var(--danger)',
          borderColor: 'rgba(248, 113, 113, 0.25)',
        };
      case 'info':
        return {
          ...baseStyles,
          background: 'rgba(96, 165, 250, 0.15)',
          color: 'var(--info)',
          borderColor: 'rgba(96, 165, 250, 0.25)',
        };
      case 'default':
      default:
        return {
          ...baseStyles,
          background: 'var(--panel)',
          color: 'var(--text-secondary)',
          borderColor: 'var(--stroke)',
        };
    }
  };

  return (
    <span className={`glass-badge ${className}`} style={getVariantStyles()}>
      {children}
    </span>
  );
};

export default GlassBadge;
